import { EmailTemplate } from "../../../views/email/EmailTypes"

export const emailTemplateLibraryDefaultsByType = (template: EmailTemplate): EmailTemplate => {
    switch (template.template_type) {

        case 'ticket_acknowledgement':
            return {
                ...template,
                connected_feature: 'tickets',
                send_to: ['requester'],
                send_method: 'automatically',
                trigger_timing: 'immediate',
                trigger_status: 'new',
                trigger_offset_unit: null,
                trigger_offset_value: null,
                add_object_pdf: false
            }

        case 'ticket_reply':
            return {
                ...template,
                connected_feature: 'tickets',
                send_to: ['requester'],
                send_method: 'manual',
                trigger_timing: null,
                trigger_status: null,
                trigger_offset_unit: null,
                trigger_offset_value: null,
                add_object_pdf: false
            }

        case 'proposal_send':
            return {
                ...template,
                connected_feature: 'proposals',
                send_method: 'manual',
                trigger_timing: null,
                trigger_status: null,
                trigger_offset_unit: null,
                trigger_offset_value: null,
                add_object_pdf: true
            }

        case 'proposal_follow_up':
            return {
                ...template,
                connected_feature: 'proposals',
                send_method: 'manual',
                trigger_timing: null,
                trigger_status: null,
                trigger_offset_unit: null,
                trigger_offset_value: null,
            }

        // Automatic template defaults temporarily commented out
        // case 'proposal_follow_up':
        //     return {
        //         ...template,
        //         connected_feature: 'proposals',
        //         send_method: 'automatically',
		// 		trigger_timing: 'immediate',
		// 		trigger_status: 'expired',
		// 		trigger_offset_unit: null,
		// 		trigger_offset_value: null,
        //     }

        case 'appointment_confirmation_request':
            return {
                ...template,
                connected_feature: 'appointments',
                send_method: 'manual',
                trigger_timing: null,
                trigger_status: null,
                trigger_offset_unit: null,
                trigger_offset_value: null,
                appointment_confirmation_button: true,
                add_object_pdf: false
            }

        case 'appointment_reminder':
            return {
                ...template,
                connected_feature: 'appointments',
                send_method: 'manual',
                trigger_timing: null,
                trigger_status: null,
                trigger_offset_unit: null,
                trigger_offset_value: null,
                add_object_pdf: false
            }

        // Automatic template defaults temporarily commented out
        // case 'appointment_reminder':
        //     return {
        //         ...template,
        //         connected_feature: 'appointments',
        //         send_method: 'automatically',
        //         trigger_timing: 'before',
        //         trigger_status: 'scheduled',
        //         trigger_offset_unit: 'days',
        //         trigger_offset_value: '1',
        //         add_object_pdf: false
        //     }

        case 'appointment_confirmation':
            return {
                ...template,
                connected_feature: 'appointments',
                send_method: 'manual',
                trigger_timing: null,
                trigger_status: null,
                trigger_offset_unit: null,
                trigger_offset_value: null,
                add_object_pdf: false
            }

        // Automatic template defaults temporarily commented out
        // case 'appointment_confirmation':
        //     return {
        //         ...template,
        //         connected_feature: 'appointments',
        //         send_method: 'automatically',
        //         trigger_timing: 'immediate',
        //         trigger_status: 'scheduled',
        //         trigger_offset_unit: null,
        //         trigger_offset_value: null,
        //         add_object_pdf: false
        //     }

        case 'job_workorder_copy':
            return {
                ...template,
                connected_feature: 'jobs',
                send_method: 'manual',
                trigger_timing: null,
                trigger_status: null,
                trigger_offset_unit: null,
                trigger_offset_value: null,
                add_object_pdf: true
            }

        // Automatic template defaults temporarily commented out
        // case 'job_workorder_copy':
        //     return {
        //         ...template,
        //         connected_feature: 'jobs',
        //         send_method: 'automatically',
        //         trigger_timing: 'immediate',
        //         trigger_status: 'completed',
        //         trigger_offset_unit: null,
        //         trigger_offset_value: null,
        //         add_object_pdf: true
        //     }

        case 'job_finished':
            return {
                ...template,
                connected_feature: 'jobs',
                send_method: 'manual',
                trigger_timing: null,
                trigger_status: null,
                trigger_offset_unit: null,
                trigger_offset_value: null,
                add_object_pdf: true
            }

        // Automatic template defaults temporarily commented out
        // case 'job_finished':
        //     return {
        //         ...template,
        //         connected_feature: 'jobs',
        //         send_method: 'automatically',
        //         trigger_timing: 'immediate',
        //         trigger_status: 'finished',
        //         trigger_offset_unit: null,
        //         trigger_offset_value: null,
        //         add_object_pdf: true
        //     }

        case 'customer_rating_request':
            return {
                ...template,
                connected_feature: 'jobs',
                send_method: 'manual',
                trigger_timing: null,
                trigger_status: null,
                trigger_offset_unit: null,
                trigger_offset_value: null,
            }

        // Automatic template defaults temporarily commented out
        // case 'customer_rating_request':
        //     return {
        //         ...template,
        //         connected_feature: 'jobs',
        //         send_method: 'automatically',
        //         trigger_timing: 'delay',
        //         trigger_status: 'finished',
        //         trigger_offset_unit: 'days',
        //         trigger_offset_value: '2',
        //     }

        case 'invoice_send':
            return {
                ...template,
                connected_feature: 'invoices',
                send_method: 'manual',
                trigger_timing: null,
                trigger_status: null,
                trigger_offset_unit: null,
                trigger_offset_value: null,
                add_object_pdf: true
            }

        case 'invoice_reminder':
            return {
                ...template,
                connected_feature: 'invoices',
                send_method: 'manual',
                trigger_timing: null,
                trigger_status: null,
                trigger_offset_unit: null,
                trigger_offset_value: null,
                add_object_pdf: true
            }

        // Automatic template defaults temporarily commented out
        // case 'invoice_reminder':
        //     return {
        //         ...template,
        //         connected_feature: 'invoices',
        //         send_method: 'automatically',
        //         trigger_timing: 'immediate',
        //         trigger_status: 'overdue',
        //         trigger_offset_unit: null,
        //         trigger_offset_value: null,
        //         add_object_pdf: true
        //     }

        case 'invoice_second_reminder':
            return {
                ...template,
                connected_feature: 'invoices',
                send_method: 'manual',
                trigger_timing: null,
                trigger_status: null,
                trigger_offset_unit: null,
                trigger_offset_value: null,
                add_object_pdf: true
            }

        // Automatic template defaults temporarily commented out
        // case 'invoice_second_reminder':
        //     return {
        //         ...template,
        //         connected_feature: 'invoices',
        //         send_method: 'automatically',
        //         trigger_timing: 'delay',
        //         trigger_status: 'reminded',
        //         trigger_offset_unit: 'days',
        //         trigger_offset_value: '3',
        //         add_object_pdf: true
        //     }

        case 'invoice_paid_notification':
            return {
                ...template,
                connected_feature: 'invoices',
                send_method: 'manual',
                trigger_timing: null,
                trigger_status: null,
                trigger_offset_unit: null,
                trigger_offset_value: null,
            }

        // Automatic template defaults temporarily commented out
        // case 'invoice_paid_notification':
        //     return {
        //         ...template,
        //         connected_feature: 'invoices',
        //         send_method: 'automatically',
        //         trigger_timing: 'immediate',
        //         trigger_status: 'paid',
        //         trigger_offset_unit: null,
        //         trigger_offset_value: null,
        //     }

        default:
            return template;
    }
}